import { MapPin, Search, Menu } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface StoreLocatorHeaderProps {
  businessName: string;
  logoUrl?: string;
  theme: any;
  totalLocations: number;
  websiteUrl?: string;
  onSearch: (query: string) => void;
  searchQuery: string;
  onMenuClick?: () => void;
  showMenuButton?: boolean;
}

const StoreLocatorHeader = ({
  businessName,
  logoUrl,
  theme,
  totalLocations,
  websiteUrl,
  onSearch,
  searchQuery,
  onMenuClick,
  showMenuButton = false,
}: StoreLocatorHeaderProps) => {
  return (
    <header
      className="bg-white shadow-sm border-b"
      style={{ borderBottomColor: theme?.primaryColor }}
    >
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2 md:gap-3 min-w-0 flex-1">
            {showMenuButton && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onMenuClick}
                className="lg:hidden flex-shrink-0"
              >
                <Menu className="h-5 w-5" />
              </Button>
            )}
            {logoUrl && (
              <img
                src={logoUrl}
                alt={businessName}
                className="h-8 w-auto md:h-10 flex-shrink-0"
              />
            )}
            <div className="min-w-0">
              <h1 className="text-sm md:text-lg lg:text-2xl font-bold text-gray-900 truncate">{businessName}</h1>
              <p className="text-xs md:text-sm text-gray-600">
                <span className="inline-flex items-center gap-1">
                  <MapPin className="h-3 w-3 md:h-4 md:w-4" />
                  {totalLocations} Locations Available
                </span>
              </p>
            </div>
          </div>

          <div className="flex flex-row items-center gap-2 md:gap-4 flex-shrink-0">
            <div className="relative hidden lg:block">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 md:h-5 md:w-5 text-gray-400" />
              <Input
                type="text"
                placeholder="Search city, state, or ZIP"
                value={searchQuery}
                onChange={(e) => onSearch(e.target.value)}
                className="pl-10 w-full md:w-64 text-sm"
              />
            </div>

            {websiteUrl && (
              <a
                href={websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-3 md:px-4 py-2 rounded-lg font-medium text-white hover:opacity-90 transition-opacity text-xs md:text-sm whitespace-nowrap"
                style={{
                  backgroundColor: theme?.primaryColor || "#0066cc",
                }}
              >
                Home
              </a>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default StoreLocatorHeader;